import React, { useEffect, useState } from "react";
import Header from "../../directives/header";
import Sidebar from "../../directives/sidebar";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { getAllReferalListAction, getUserListById, updateReferralDetails } from "../../Action/action";
import { Link, useParams } from "react-router-dom";
import config from "../../coreFIles/config";
import { GrCopy } from "react-icons/gr";
import { IoCopyOutline } from "react-icons/io5";

const UserDetails = () => {
  const [userDetail, setUserDetail] = useState({})
  const [referralList, setReferralList] = useState({});
  const [tokenPurchaseList, setTokenPurchaseList] = useState([])
  const [refferalPercentage, setRefferalPercentage] = useState('');
  const [isInfluencer, setIsInfluencer] = useState(true);

  const [approval, setApproval] = useState('');

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const { id } = useParams()
  useEffect(() => {
    getUserDetail()
  }, []);

  const getUserDetail = async () => {
    let res = await getUserListById(id);
    if (res.success) {
      setUserDetail(res?.data);
      setApproval(res?.data?.adminApproval)
      setRefferalPercentage(res?.data?.refferalPercentage)
    }
  };

  const getUserReferralList = async () => {
    setLoading(true);
    setError('');
    let res = await getAllReferalListAction(id);
    setLoading(false);
    if (res.success) {
      setReferralList(res.data);
    } else {
      setReferralList([]);
      setError('No referral records found.');
    }
  };

  

  const handleInputChange = (e) => {
    const input = e.target.value;
    if (input > 100) {
      toast.error("Percentage is not more than 100")
      return;
    }

    if (!/^\d*$/.test(input)) {
      toast.error("Only numbers are allowed in this field");
      return
    } else {
      setRefferalPercentage(input);
    }
  };

  const handleSubmit = async () => {
    if (!refferalPercentage && approval === null) {
      return toast.error('Please fill in at least one field.');
    }

    if (refferalPercentage > 50) {
      return toast.error('Refferal Percentage should be less than 50%');
    }

    try {
      const updateData = {};
      if (refferalPercentage !== null) updateData.refferalPercentage = refferalPercentage;
      if (approval !== null) updateData.approval = approval;

      const result = await updateReferralDetails(updateData, id);


      if (result.success) {
        toast.success('User updated successfully!');
        setTimeout(() => {
          window.location.href = `${config.baseUrl}influencer`
        }, );
        
      } else {
        toast.error('Failed to update user.');
      }
    } catch (error) {
      toast.error('An error occurred while updating the user.');
    }
  }



  const refListColumns = [
    {
      key: "Sno.",
      text: "Sno.",
      cell: (row, index) => index + 1,
    },
    {
      key: "firstName",
      text: "User Name",
      cell: (item) => {
        return (
          <>
            <a style={{ color: '#fff' }} href={`${config.baseUrl}userdetail/` + item._id}>{item.firstName + ' ' + item.lastName}</a>
          </>
        )
      },
    },
    {
      key: "email",
      text: "Email",
      cell: (item) => {
        return <>{item.email}</>;
      },
    },
    {
      key: "datetime",
      text: "Transaction Date",
      cell: (item) => {
        return `${moment(item.datetime).format("DD-MM-YYYY H:s")}`;
      },
    },
    {
      key: "isBlock",
      text: "Status",
      cell: (item) => {
        return (
          <>
             <span style={{ color: item?.isBlock == true ? 'red' : 'green' }}>
              {item?.isBlock == true ? 'Blocked' : 'Active'}
            </span>
          </>
        );
      }
    },
  ];

  const tokenPurchaseListColumns = [
    {
      key: "Sno.",
      text: "Sno.",
      cell: (row, index) => index + 1,
    },
    {
      key: "fullName",
      text: "User Name",
      cell: (item) => <> {item?.userInfo?.firstName + " " + item?.userInfo?.lastName}</>,
    },
    {
      key: "tokenAmount",
      text: "Token Amount",
      cell: (item) => <> {item.tokenAmount + ' ' + config.currencyName} </>,
    },
    {
      key: "equivalentAmount",
      text: "Crypto Amount",
      cell: (item) => <> {item?.paymentType == "SOLANA"
        ? item?.equivalentAmount + " SOL"
        : "$" + item?.equivalentAmount}</>,
    },
    {
      text: "Wallet Address",
      cell: (row) => {
        const walletAddress = row.walletAddress;
        return (
          <>
            {walletAddress
              ? walletAddress?.substring(0, 4) +
              "...." +
              walletAddress?.substring(walletAddress.length - 4)
              : "NA"}
            {walletAddress ? (
              <CopyToClipboard
                text={walletAddress}
                onCopy={() => {
                  toast.success("Copied!");
                }}
              >
                <span style={{ cursor: "pointer" }} className="ms-2">
                  <IoCopyOutline />
                </span>
              </CopyToClipboard>
            ) : (
              ""
            )}
          </>
        );
      },
      center: true,
    },
    {
      text: "Transaction Hash",
      cell: (row) => {
        const trxHash = row.trxHash;
        return (
          <>
            {row.paymentType == "Paypal" ? (
              trxHash
            ) : trxHash ? (
              <a style={{ color: "#fff" }}
                href={`${config.solanaTrxUrl1}${trxHash}${config.solanaTrxUrl2}`}
                target="_blank"
              >
                {trxHash?.substring(0, 4) +
                  "...." +
                  trxHash?.substring(trxHash.length - 4)}
              </a>
            ) : (
              "NA"
            )}
          </>
        );
      },
      center: true,
    },
    {
      key: "createdAt",
      text: "Transaction Date",
      cell: (item) => <> {moment(item.createdAt).format("DD/MM/YY")}</>,
    },
    {
      key: "paymentType",
      text: "Payment Type",
      cell: (item) => <> {item.paymentType}</>,
    },
    {
      key: "action",
      text: "Status",
      cell: (item) => (
        <>

          {item?.status == 0 ? (
            <span className="badge rounded-pill bg-pending" style={{ width: 100 }} >Pending</span>
          ) : item?.status == 1 ? (
            <span className="badge rounded-pill bg-success" style={{ width: 100 }} >Success</span>
          ) : (
            <span className="badge rounded-pill bg-danger" style={{ width: 100 }}>Rejected</span>
          )
          }
        </>
      ),
    },
  ];

  const configForTable = {
    page_size: 10,
    length_menu: [10, 20, 50],
    show_filter: true,
    show_pagination: true,
    pagination: "advance",

  };

  const copieBtn = async () => {
    toast.success(`Copied!`);
  };

  const handleBack = () => {
    window.history.back(); 
  };

  return (
    <>
      <div className="wrapper h-auto">
        <Header />
        <Sidebar />
        <Toaster />
        <div className="content-wrapper">
          <div className="container-full">
            <div className="box-header with-border">

              <div to={`${config.baseUrl}users`} className="btn btn-primary" onClick={handleBack} >
                Back
              </div>
            </div>
            <section>
              <div className=" p-4">
                <div className="row">
                  <div className="col-md-12  mt-3">
                    <ul className="nav nav-tabs customtab2" role="tablist">
                      <li className="nav-item" onClick={() => getUserDetail()}>
                        <a
                          className="nav-link active"
                          data-bs-toggle="tab"
                          href="#userProfileSection"
                          role="tab"
                          aria-selected="true"
                        >
                          <i className="fa fa-user"></i> &nbsp;
                          <span className="">{userDetail.first_name} Profile</span>
                        </a>
                      </li>


                        <li className="nav-item" onClick={() => getUserReferralList()}>
                          <a
                            className="nav-link"
                            data-bs-toggle="tab"
                            href="#referralListSection"
                            role="tab"
                            aria-selected="true"
                          >
                            <i className="fa fa-users"></i> &nbsp;
                            <span className="">Referral List</span>
                          </a>
                        </li>

                    </ul>
                  </div>

                  <div className="col-md-12  mt-3">
                    <div className="tab-content">
                      <div className="tab-pane active" id="userProfileSection" role="tabpanel">
                        {userDetail.isInfluencer ?
                          <>
                            <div className="box">
                              <div className="box-header with-border">
                                <h3 className="box-title" style={{ fontWeight: 600 }}>Influencer Profile</h3>
                              </div>
                              <div className="box-body">
                                <div className="row">
                                  <div className="col-md-6" >
                                    <table className="table table-bordered table-hover profileTable" style={{ color: "white", borderRadius: 20 }}>
                                      <thead >
                                        <tr>
                                          <th>User Name</th>
                                          <td>{userDetail.firstName + ' ' + userDetail.lastName}</td>
                                        </tr>
                                        <tr>
                                          <th>Email</th>
                                          <td>{userDetail.email}</td>
                                        </tr>
                                       
                                        <tr>
                                          <th>Country</th>
                                          <td>{userDetail.country ? userDetail.country : 'NA'}</td>
                                        </tr>

                                        <tr>
                                          <th>Mode of communication</th>
                                          <td>{userDetail.modeOfCommunication ? userDetail.modeOfCommunication : 'NA'}</td>
                                        </tr>

                                        <tr>
                                          <th>{userDetail.modeOfCommunication == 'WhatsApp' ? 'WhatsApp Number' : 
                                            userDetail.modeOfCommunication == 'Skype' ? 'Skype Id':
                                            userDetail.modeOfCommunication == 'Facebook' ? 'Facebook Id':
                                            userDetail.modeOfCommunication == 'Telegram' ? 'Telegram Number':""}</th>
                                          <td>{userDetail.modeOfCommunicationData ? userDetail.modeOfCommunicationData : 'NA'}</td>
                                        </tr>
                                        <tr>
                                          <th>Phone Number </th>
                                          <td>{userDetail.phoneNumber ? userDetail.phoneNumber : 'NA'}</td>
                                        </tr>
                                      
                                        <tr>
                                          <th>Referral Code</th>
                                          <td>{userDetail.referralCode ? userDetail.referralCode : 'NA'}</td>
                                        </tr>
                                        <tr>
                                          <th>Wallet Address</th>
                                          <td>
                                            {userDetail?.walletAddress
                                              ? userDetail?.walletAddress?.substring(0, 6) +
                                              "...." +
                                              userDetail?.walletAddress?.substring(
                                                userDetail?.walletAddress?.length - 6
                                              )
                                              : "NA"}
                                            {userDetail?.walletAddress &&
                                              <CopyToClipboard text={userDetail?.walletAddress}>
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={copieBtn}
                                                  style={{ cursor: "pointer", color: "#ea5536" }}
                                                >
                                                  &nbsp;  <GrCopy />
                                                </span>
                                              </CopyToClipboard>
                                            }
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Email Verified</th>
                                          <td>
                                            {userDetail.Status === true ?
                                              <span className="badge rounded-pill bg-success">Active</span>

                                              :
                                              <spna className="badge rounded-pill bg-danger">Inactive</spna>
                                            }
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Registration Date</th>
                                          <td>{moment(userDetail.Date).format('DD-MM-YYYY')}</td>
                                        </tr>
                                        <tr>
                                          <th>Referral Percentage</th>
                                          <td>{userDetail.refferalPercentage ? userDetail.refferalPercentage : 'NA'}</td>
                                        </tr>
                                        <tr>
                                          <th>Other Links</th>
                                          <td>
                                            {userDetail.socialMediaLink
                                              ? userDetail.socialMediaLink.length > 6
                                                ? userDetail.socialMediaLink.substring(0, 25) + "..."
                                                : userDetail.socialMediaLink
                                              : "NA"}

                                            {userDetail?.socialMediaLink &&
                                              <CopyToClipboard text={userDetail?.socialMediaLink}>
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={copieBtn}
                                                  style={{ cursor: "pointer", color: "#ea5536" }}
                                                >
                                                  &nbsp;  <GrCopy />
                                                </span>
                                              </CopyToClipboard>
                                            }

                                          </td>

                                         
                                        </tr>
                                        <tr>
                                          <th>Audience Description</th>
                                          <td>{userDetail.description ? userDetail.description : 'NA'}</td>
                                        </tr>
                                      </thead>
                                    </table>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="row">
                                      <div className="col-lg-8">
                                        <div className="form-group">
                                          <label htmlFor="refferalPercentage">Referral Percentage</label>
                                          <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Referral Percentage"
                                            name="refferalPercentage"
                                            onChange={handleInputChange}
                                            value={refferalPercentage}
                                          />

                                        </div>
                                    
                                        <div className="form-group">
                                          <label htmlFor="approval">Influencer Profile Verification Status</label>
                                          <select
                                            id="approval"
                                            className="form-control"
                                            value={approval}
                                            onChange={(e) => setApproval(e.target.value)}
                                          >
                                            <option value="0">Pending</option>
                                            <option value="1">Approve</option>
                                            <option value="2">Reject</option>
                                          </select>

                                        </div>
                                        <button
                                          className="btn btn-primary mt-3"
                                          onClick={handleSubmit}
                                        >
                                          Submit
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                          :
                          <>
                            <div className="box">
                              <div className="box-header with-border">
                                <h3 className="box-title" style={{ fontWeight: 600 }}>User Profile</h3>
                              </div>
                              <div className="box-body">
                                <div className="row">
                                  <div className="col-md-6" >
                                    <table className="table table-bordered table-hover profileTable" style={{ color: "white", borderRadius: 20 }}>
                                      <thead >
                                        <tr>
                                          <th>User Name</th>
                                          <td>{userDetail.firstName + ' ' + userDetail.lastName}</td>
                                        </tr>
                                        <tr>
                                          <th>Email</th>
                                          <td>{userDetail.email}</td>
                                        </tr>


                                        <tr>
                                          <th>Email Verified</th>
                                          <td>
                                            {userDetail.Status === true ?
                                              <span className="badge rounded-pill bg-primary">Active</span>
                                              :
                                              <spna className="badge rounded-pill bg-danger">Inactive</spna>
                                            }
                                          </td>
                                        </tr>
                                        <tr>
                                          <th>Registration Date</th>
                                          <td>{moment(userDetail.Date).format('DD-MM-YYYY')}</td>
                                        </tr>
                                     
                                      </thead>
                                    </table>
                                  </div>
                                
                                </div>
                              </div>
                            </div>
                          </>
                        }

                      </div>

                      <div className="tab-pane" id="referralListSection" role="tabpanel">
                        <div className="box">
                          <div className="box-header with-border">
                            <h3 className="box-title" style={{ fontWeight: 600 }}>Referral List</h3>

                          </div>
                          <div className="box-body">
                            {/* {loading ? (
                              <p style={{ color: 'white' }}>Loading...</p>
                            ) : error ? (
                              <p style={{ color: 'white' }}>{error}</p>
                            ) : referralList.length > 0 ? (
                              <ReactDatatable
                                config={configForTable}
                                records={referralList}
                                columns={refListColumns}
                              />
                            ) : (
                              <p>No records found.</p>
                            )} */}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div >
      </div >
    </>
  );
};
export default UserDetails;

